import { render, staticRenderFns } from "./rejected_spoiltstock.vue?vue&type=template&id=1bd45360&"
import script from "./rejected_spoiltstock.vue?vue&type=script&lang=js&"
export * from "./rejected_spoiltstock.vue?vue&type=script&lang=js&"
import style0 from "./rejected_spoiltstock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports